import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ThemeContext from '~app/components/Survey/ThemeContext';
import './survey-title.scss';

const SurveyTitle = ({ title }) => {
  const theme = useContext(ThemeContext);
  return (
    <div style={theme.palette} className="sm-survey-title--container" data-testid="SurveyTitle__Container">
      {title}
    </div>
  );
};

SurveyTitle.propTypes = {
  title: PropTypes.string,
};

SurveyTitle.defaultProps = {
  title: '',
};

export default SurveyTitle;
